

import React, { useState } from 'react';
import axios from 'axios';

function OutilNumerique() {
  const [formData, setFormData] = useState({
    partenariat: '',
    autreTexte: '',
  });

  const [confirmationMessage, setConfirmationMessage] = useState('');
  const [showPopup, setShowPopup] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setConfirmationMessage('');
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    await axios.post(`${process.env.REACT_APP_API_URL}/outil-numerique`, formData);
    setConfirmationMessage('✅ Message envoyé. Nous vous enverrons la suite par email !');
    setFormData({ partenariat: '', autreTexte: '' });
  } catch (err) {
    setConfirmationMessage('❌ Erreur lors de l’envoi du formulaire.');
  } finally {
    setShowPopup(true);
  }
};


  return (
    <div style={{
      marginTop: '5rem',
      padding: '2rem',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      gap: '3rem',
      flexWrap: 'wrap',
    }}>
      {/* Description à gauche */}
      <div style={{
        flex: '1',
        minWidth: '280px',
        maxWidth: '400px',
        color: '#333',
        lineHeight: '1.6',
      }}>
        <h2 style={{ marginBottom: '1rem' }}>Pourquoi un partenariat numérique ?</h2>
        <p>
          Nous croyons en la puissance des collaborations numériques pour
          améliorer l'efficacité, l'innovation et l'accessibilité des services.
        </p>
        <p>
          Que vous soyez une entreprise, une organisation ou un particulier,
          rejoignez-nous pour construire ensemble des solutions technologiques adaptées.
        </p>
      </div>

      {/* Formulaire à droite */}
      <div style={{
        flex: '1',
        minWidth: '300px',
        maxWidth: '500px',
        backgroundColor: '#f9f9f9',
        padding: '2rem',
        borderRadius: '10px',
        boxShadow: '0 0 15px rgba(0,0,0,0.1)'
      }}>
        <h2 style={{ textAlign: 'center', marginBottom: '1.5rem', color: '#333' }}>
          Partenariat Numérique
        </h2>

        <form onSubmit={handleSubmit}>
          <label style={{ display: 'block', marginBottom: '1rem', color: '#444' }}>
            Type de partenariat :
            <select
              name="partenariat"
              value={formData.partenariat}
              onChange={handleChange}
              required
              style={{
                display: 'block',
                width: '100%',
                padding: '0.5rem',
                marginTop: '0.5rem',
                borderRadius: '5px',
                border: '1px solid #ccc',
                backgroundColor: '#fff'
              }}
            >
              <option value="">-- Sélectionnez --</option>
              <option value="industrie">Industrie</option>
              <option value="ressource humaine">Ressource Humaine</option>
              <option value="commercial">Commercial</option>
              <option value="autre">Autre</option>
            </select>
          </label>

          {formData.partenariat === 'autre' && (
            <label style={{ display: 'block', marginBottom: '1rem', color: '#444' }}>
              Veuillez préciser :
              <input
                type="text"
                name="autreTexte"
                value={formData.autreTexte}
                onChange={handleChange}
                required
                placeholder="Précisez votre partenariat"
                style={{
                  display: 'block',
                  width: '100%',
                  padding: '0.5rem',
                  marginTop: '0.5rem',
                  borderRadius: '5px',
                  border: '1px solid #ccc',
                }}
              />
            </label>
          )}

          <button
            type="submit"
            style={{
              width: '100%',
              padding: '0.75rem',
              backgroundColor: '#28a745',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '1rem'
            }}
          >
            Envoyer
          </button>
        </form>
      </div>

      {/* Popup */}
      {showPopup && (
        <div style={{
          position: 'fixed',
          top: 0, left: 0, right: 0, bottom: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '2rem',
            borderRadius: '10px',
            maxWidth: '400px',
            width: '90%',
            textAlign: 'center',
            boxShadow: '0 5px 15px rgba(0,0,0,0.3)'
          }}>
            <p style={{
              color: confirmationMessage.startsWith('✅') ? '#28a745' : '#dc3545',
              fontWeight: 'bold'
            }}>
              {confirmationMessage}
            </p>
            <button
              onClick={() => setShowPopup(false)}
              style={{
                marginTop: '1rem',
                padding: '0.5rem 1.5rem',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '5px',
                cursor: 'pointer'
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default OutilNumerique;
